import { SUSPENSE_COMPETITOR, SUSPENSE_REASON } from '../../../../../../views/billing/subscription/constants';

export default {
  title: 'Automatische facturering',
  buttons: {
    add_subscription: 'Abonnement toevoegen',
    suspend_company: 'Restaurant opschorten',
    restore_company: 'Restaurant herstellen',
    edit_suspend: 'Opschortingsinfo bewerken',
    confirm: 'Bevestigen',
    cancel: 'Annuleren',
  },
  modals: {
    suspend_company: {
      title: 'Weet u zeker dat u {{company}} wilt opschorten?',
      description:
        'Dit annuleert alle actieve abonnementen, schakelt live bestellingen uit en stelt de restauranteigenaar per e-mail op de hoogte. Selecteer een reden voordat u bevestigt.',
      suspense_reason: {
        label: 'Selecteer reden voor opschorting',
        placeholder: 'Kies een reden',
        options: {
          [SUSPENSE_REASON.ClosedOrOwnershipChange]: 'Gesloten of eigendomswijziging',
          [SUSPENSE_REASON.LowRoi]: 'Lage ROI',
          [SUSPENSE_REASON.PricingFeesSensitivity]: 'Gevoeligheid voor prijzen/kosten',
          [SUSPENSE_REASON.MissingIntegrationsProductGaps]: 'Ontbrekende integraties/productleemten',
          [SUSPENSE_REASON.PoorOnboardingActivation]: 'Slechte onboarding/activering',
          [SUSPENSE_REASON.SupportDissatisfaction]: 'Ontevredenheid over support',
          [SUSPENSE_REASON.SwitchedToCompetitor]: 'Overgestapt naar concurrent/marktplaats/DIY',
          [SUSPENSE_REASON.MarketingPerformanceDisappointment]: 'Teleurstelling in marketingprestaties',
          [SUSPENSE_REASON.WrongRegistrationData]: 'Onjuiste registratie / gegevens',
        },
        validation: {
          required: 'Kies een reden',
        },
      },
      suspense_competitor: {
        label: 'Naar welke concurrent zijn ze overgestapt?',
        placeholder: 'Kies een concurrent',
        options: {
          [SUSPENSE_COMPETITOR.Allo]: 'Allo',
          [SUSPENSE_COMPETITOR.Sides]: 'Slice',
          [SUSPENSE_COMPETITOR.Ordersmart]: 'Ordersmart',
          [SUSPENSE_COMPETITOR.RobinCook]: 'Robin Cook',
          [SUSPENSE_COMPETITOR.Lightspeed]: 'Lightspeed',
          [SUSPENSE_COMPETITOR.GastroMaster]: 'Gastro Master',
          [SUSPENSE_COMPETITOR.Dish]: 'Dish',
          [SUSPENSE_COMPETITOR.Other]: 'Overig',
        },
        validation: {
          required: 'Kies een concurrent',
        },
      },
      suspense_reason_notes: {
        label: 'Aanvullende context (optioneel)',
        placeholder: 'Geef aanvullende details',
      },
    },
    restore_company: {
      title: 'Weet u zeker dat u {{company}} wilt herstellen?',
      description: 'U moet nog wel handmatig een abonnement aanmaken en live bestellingen inschakelen.',
    },
  },
  toasts: {
    failed_to_load_data: 'Abonnementsgegevens laden mislukt',
    failed_to_suspend_company: 'Restaurant opschorten mislukt. Neem contact op met technische ondersteuning',
    failed_to_restore_company: 'Restaurant herstellen mislukt. Neem contact op met technische ondersteuning',
  },
};
